var map = {
	"./Bar.png": 908012,
	"./BarBar.png": 787285,
	"./Elephant.png": 956596,
	"./ElephantHalf.png": 341319,
	"./Giraffe.png": 185687,
	"./GiraffeHalf.png": 35884,
	"./Line.png": 104685,
	"./LineGraph.png": 543653,
	"./LineGraph1.png": 876856,
	"./LineGraph2.png": 222611,
	"./LineGraph3.png": 67402,
	"./LineGraph4.png": 434277,
	"./Lion.png": 576933,
	"./LionHalf.png": 963310,
	"./Pictograph.png": 456690,
	"./Pie1.png": 552536,
	"./Pie2.png": 727027,
	"./Pie3.png": 876266,
	"./Pie4.png": 860933,
	"./Pie5.png": 543420,
	"./Sequence.png": 975508,
	"./Tally.png": 527445,
	"./Tally1.png": 50344,
	"./Tally2.png": 335619,
	"./Tally3.png": 18042,
	"./Tally4.png": 774549,
	"./Tally5.png": 405452,
	"./TallyLine.png": 675827,
	"./TallyStrike.png": 50643,
	"./TimeTable.png": 195938,
	"./Zebra.png": 935939,
	"./ZebraHalf.png": 648104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198779;